import classnames from "classnames";
import React from "react";

import { RichTextBlock, Slice } from "../components";
import { ISliceText } from "../types";

export const Text = ({
  slice_type,
  primary,
  items,
}: ISliceText): JSX.Element | null => {
  const { class_name: className, background_color: backgroundColor } = primary;

  const isEmpty = items.every(
    ({ text_rich_text }) => text_rich_text.length === 0
  );

  if (isEmpty) {
    return null;
  }

  return (
    <Slice
      className={classnames("slice-text", className)}
      backgroundColor={backgroundColor}
    >
      {items.map(({ text_rich_text }, i: number) => (
        <RichTextBlock render={text_rich_text} key={i} />
      ))}
    </Slice>
  );
};
